export default __webpack_public_path__ + "static/media/question002_answer_user002.5f2aa0fb.png";